// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/Departments/Managers/Finance";

export default function Managers() {
	const Icon = getOutlinedPositionIcon({ position: "Finance Managers" });
	return (
		<PageLayer title={"Finance Managers Pay Plans"} icon={Icon}>
			<Layer />
		</PageLayer>
	);
}
